import { GROUP_POSITION_VALUES } from 'assets/js/pages/campaign-settings/campaign-event/table-seating/constants';
import {
    GroupPosition,
    SeatingTicket,
} from 'assets/js/pages/campaign-settings/campaign-event/table-seating/types';

interface TicketWithPosition {
    ticket: SeatingTicket;
    groupPosition: GroupPosition;
    isFirstInList: boolean;
    isLastInList: boolean;
}

const toGroupPosition = (memberCount: number, positionInGroup: number): GroupPosition => {
    if (memberCount === 1) return GROUP_POSITION_VALUES.SOLO;
    if (positionInGroup === 0) return GROUP_POSITION_VALUES.FIRST;
    if (positionInGroup === memberCount - 1) return GROUP_POSITION_VALUES.LAST;
    return GROUP_POSITION_VALUES.MIDDLE;
};

const findGroupMemberIndices = (tickets: SeatingTicket[], groupId: string): number[] =>
    tickets
        .map((ticket, index) => (ticket.ticket_group_id === groupId ? index : -1))
        .filter(index => index !== -1);

const getPositionInGroup = (
    tickets: SeatingTicket[],
    ticketIndex: number,
    groupId: string | null,
): number => {
    if (!groupId) return 0;

    const memberIndices = findGroupMemberIndices(tickets, groupId);
    const position = memberIndices.indexOf(ticketIndex);

    return position === -1 ? 0 : position;
};

const toTicketWithPosition = (
    ticket: SeatingTicket,
    index: number,
    allTickets: SeatingTicket[],
): TicketWithPosition => {
    const groupId = ticket.ticket_group_id;
    const memberCount = groupId ? findGroupMemberIndices(allTickets, groupId).length : 1;
    const positionInGroup = getPositionInGroup(allTickets, index, groupId);
    const lastIndex = allTickets.length - 1;

    return {
        ticket,
        groupPosition: toGroupPosition(memberCount, positionInGroup),
        isFirstInList: index === 0,
        isLastInList: index === lastIndex,
    };
};

const calculateGroupPositions = (tickets: SeatingTicket[]): TicketWithPosition[] =>
    tickets.map((ticket, index) => toTicketWithPosition(ticket, index, tickets));

export { calculateGroupPositions };
